/**
* DevExpress Dashboard (item-data-axis-names.js)
* Version:  23.1.4
* Build date: Jul 18, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.itemDataAxisNames = void 0;
exports.itemDataAxisNames = {
    defaultAxis: 'Default',
    chartSeriesAxis: 'Series',
    chartArgumentAxis: 'Argument',
    sparklineAxis: 'Sparkline',
    pivotColumnAxis: 'Column',
    pivotRowAxis: 'Row'
};
